const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AutoReturnAndResendUrls = {
    checkStatus: `${Backofficebff}/v1/AutoReturnAndResend/check-status`,
    processBulk: `${Backofficebff}/v1/AutoReturnAndResend/process-bulk`,
    reports: `${Backofficebff}/v1/AutoReturnAndResend/reports`,
    reportDetails: `${Backofficebff}/v1/AutoReturnAndResend/report-details`,
};
